import 'magnific-popup';
import { documentReady } from './utils';
import { magnificPopupTranslations } from './translations';
import $ from "jquery";

//TODO: mb remove magnificPopup?

const Popins = {
    initialize: () => {
        //TODO:
        // window.$ = $;
        // window.magnificPopup = $.magnificPopup;   

        documentReady(() => {
            // Get the right translations with the lang attribute
            if (document.documentElement.lang && magnificPopupTranslations[document.documentElement.lang]) {
                $.extend(true, $.magnificPopup.defaults, magnificPopupTranslations[document.documentElement.lang]);
            }

            const options = {
                removalDelay: 300,
                mainClass: 'mfp-fade',
                callbacks: {
                    open: () => document.documentElement.style.marginRight = `${window.customScrollbarWidth}px`,
                }
            };

            document.querySelectorAll('.js-popin-single').forEach((element) => {
                $(element).magnificPopup({
                    ...options
                });
            });

            document.querySelectorAll('.js-popin-gallery').forEach((element) => {
                $(element).magnificPopup({
                    delegate: 'a',
                    gallery: {
                        enabled:true
                    },
                    ...options
                });
            });
        });
    }
}

Popins.initialize();

export default Popins;
